<!-- 
 Copy of MatSelect's template, customized to support our UiMatVirtualSelectComponent.

 The only thing we're changing is customizing the content projection to support our virtual
  component, which provides a filter to search values in long lists and optimizations for loading of large lists

 This HTML comes from https://github.com/angular/components/blob/10.2.7/src/material/select/select.html
 When upgrading Angular to version 11+, it's likely there'll be a need to re-grab the HTML 

 Having a shadow copy of an official Angular file is undesirable, but this is a firm upgrade from the previous
  solution of using a mixin to copy the MatSelect template + string-replace the <ng-content> tag (which is ineffective in Angular 9+,
  and with our implementation didn't seem to work with AOT)
 -->
<div cdk-overlay-origin class="mat-mdc-select-trigger" (click)="toggle()"
  #fallbackOverlayOrigin="cdkOverlayOrigin" #trigger>
  <div class="mat-mdc-select-value" [ngSwitch]="empty" [attr.id]="_valueId">
    <span class="mat-mdc-select-value-text" *ngSwitchCase="false"
          [ngSwitch]="!!customTrigger">
      <span *ngSwitchDefault>{{triggerValue || '\u00A0'}}</span>
      <ng-content select="mat-mdc-select-trigger" *ngSwitchCase="true"></ng-content>
    </span>
  </div>

  <div class="mat-mdc-select-arrow-wrapper">
    <div class="mat-mdc-select-arrow">
      <!-- Use an inline SVG, because it works better than a CSS triangle in high contrast mode. -->
      <svg viewBox="0 0 24 24" width="24px" height="24px" focusable="false" aria-hidden="true">
        <path d="M7 10l5 5 5-5z"/>
      </svg>
    </div>
  </div>
</div>

<ng-template cdk-connected-overlay cdkConnectedOverlayLockPosition
             cdkConnectedOverlayHasBackdrop
             cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
             [cdkConnectedOverlayPanelClass]="_overlayPanelClass"
             [cdkConnectedOverlayScrollStrategy]="_scrollStrategy"
             [cdkConnectedOverlayOrigin]="_preferredOverlayOrigin || fallbackOverlayOrigin"
             [cdkConnectedOverlayOpen]="panelOpen"
             [cdkConnectedOverlayPositions]="_positions"
             [cdkConnectedOverlayWidth]="_overlayWidth" (backdropClick)="close()"
             (attach)="_onAttached()" (detach)="close()">
  <div class="mat-select-panel-wrap" [@transformPanelWrap]>
    <div #panel role="listbox" tabindex="-1"
         class="mat-mdc-select-panel mdc-menu-surface mdc-menu-surface--open {{ _getPanelTheme() }}"
         [attr.id]="id + '-panel'" [attr.aria-multiselectable]="multiple"
         [attr.aria-label]="ariaLabel || null"
         [attr.aria-labelledby]="_getPanelAriaLabelledby()"
         [ngClass]="panelClass"
         [@transformPanel]="'showing'"
         (@transformPanel.done)="_panelDoneAnimatingStream.next($event.toState)"
         (keydown)="_handleKeydown($event)">
      <!-- Customization start:  Official mat-select just uses <ng-content></ng-content> here. -->
      <ng-content
                  select="ui-mat-virtual-select-header, [uiMatVirtualSelectHeader]">
      </ng-content>
      <ui-virtual-repeat [vrActivated]="true" #virtualPanel
                         [vrItems]="originalOptionList"
                         [vrChildHeight]="optionItemHeight"
                         [style.maxHeight.px]="selectPanelMaxHeight"
                         [vrItemsToBuffer]="itemsToBuffer"
                         (vrVirtualItemsChange)="virtualOptionList = $event">
        <ng-content></ng-content>
      </ui-virtual-repeat>
      <ng-container *ngIf="showCloseButton">
        <mat-divider></mat-divider>
        <div class="ui-mat-virtual-select-close-button" fxLayout="row"
             fxLayoutAlign="end center">
          <button type="button" mat-raised-button (click)="close()">CLOSE
          </button>
        </div>
      </ng-container>
      <!-- Customization end -->
    </div>
  </div>
</ng-template>